import React from "react";
import Banner from "../assets/get-demo-section-bg.jpg";
import BoxBackground from "../assets/get-demo-box-bg.jpg";
import PlayIcon from "../assets/play.svg";
import SupportIcon from "../assets/support.svg";
import { Link, useLocation } from "react-router-dom";

export const DemoInterestedSection = ({ acfData }) => {
  const location = useLocation();
  const handleClick = (e) => {
    if (location.pathname === "/contact-us") {
      e.preventDefault(); // Prevent re-navigation
      window.scrollTo({ top: 0, behavior: "smooth" }); // Smooth scroll to top
    }
  };
  // Fallback if acfData or item array is missing
  const defaultItems = [
    {
      get_a_demo_now_item_icon: { url: PlayIcon, title: "Play Icon" },
      get_a_demo_now_item_title: "Book a demo today",
      get_a_demo_now_item_detail: "See for yourself how managing your hotel, store or tour... should be",
      get_a_demo_now_item_button_text: "Request A Demo",
      get_a_demo_now_item_button_url: "/contact-us",
      get_a_demo_now_item_background_image: { url: BoxBackground },
    },
    {
      get_a_demo_now_item_icon: { url: SupportIcon, title: "Support Icon" },
      get_a_demo_now_item_title: "Ask us anything...",
      get_a_demo_now_item_detail: "(and chat with a real human)",
      get_a_demo_now_item_button_text: "Get Answers",
      get_a_demo_now_item_button_url: "/contact-us",
      get_a_demo_now_item_background_image: { url: BoxBackground },
    },
  ];

  const sectionTitle = acfData?.get_a_demo_now_title || "Get a Demo Now!";
  const demoItems = acfData?.get_a_demo_now_item || defaultItems;



  return (
    <section
      id="interestedBox"
      className="py-[54px] mx-auto bg-no-repeat bg-cover bg-center"
      style={{ backgroundImage: `url(${Banner})` }}
    >
      <div className="w-full max-w-[1570px] px-4 mx-auto">
        <div className="flex flex-wrap -mx-4 gap-y-8 lg:gap-y-11">
          <div className="w-full max-w-full px-4">
            <div className="max-w-[894px] mx-auto text-center">
              <h2 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-none text-white mb-3">
                {sectionTitle}
              </h2>
            </div>
          </div>

          {demoItems.map((item, index) => (
            <div key={index} className="w-full lg:w-1/2 max-w-full px-4">
              <div
                className="p-6 sm:p-10 lg:p-14 rounded-[21px] bg-no-repeat bg-cover bg-center h-full"
                style={{
                  backgroundImage: `url(${item.get_a_demo_now_item_background_image?.url})`,
                }}
              >
                <div className="flex flex-col gap-4 mb-6">
                  <img
                    src={item.get_a_demo_now_item_icon?.url}
                    alt={item.get_a_demo_now_item_icon?.title}
                    height="56"
                    width="56"
                  />
                  <h3 className="text-2xl sm:text-3xl font-normal leading-10 text-[#121212]">
                    {item.get_a_demo_now_item_title}
                  </h3>
                  <p className="text-lg font-light leading-7 text-[#333333]">
                    {item.get_a_demo_now_item_detail}
                  </p>
                </div>
                <Link
                  to={item.get_a_demo_now_item_button_url}
                  onClick={handleClick}
                  className="inline-block text-lg font-bold leading-6 text-white bg-[#5fa3b2] py-4 px-9 rounded-xl transition-all ease-in-out duration-500 hover:bg-[#FAA42A]"
                >
                  {item.get_a_demo_now_item_button_text}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DemoInterestedSection;
